import { ref } from 'vue'

export type Asset = { name: string; src: string }

export function useAssetLoader() {
    const isLoaded = ref(false)
    let loadedCount = 0

    const pcAssets: Asset[] = [
        {
            name: 'add-table@2x',
            src: require('@/assets/imgs/add-table@2x.png')
        },
        { name: 'bet-start', src: require('@/assets/imgs/bet-start.png') },
        { name: 'd-bg', src: require('@/assets/imgs/d-bg.png') },
        { name: 't_right', src: require('@/assets/imgs/t_right.png') },
        { name: 'h_diamonds', src: require('@/assets/imgs/h_diamonds.png') },
        { name: 'h_hearts', src: require('@/assets/imgs/h_hearts.png') },
        { name: 'h_spades', src: require('@/assets/imgs/h_spades.png') },
        { name: 'loader', src: require('@/assets/imgs/loader.gif') },
        { name: 't_left', src: require('@/assets/imgs/t_left.png') },
        {
            name: 'cancel_confimed_bet',
            src: require('@/assets/imgs/cancel_confimed_bet.png')
        },
        { name: 'v_clubs', src: require('@/assets/imgs/v_clubs.png') },
        { name: 'v_diamonds', src: require('@/assets/imgs/v_diamonds.png') },
        { name: 'v_hearts', src: require('@/assets/imgs/v_hearts.png') },
        { name: 'v_spades', src: require('@/assets/imgs/v_spades.png') },
        { name: 'bet-stop', src: require('@/assets/imgs/bet-stop.png') },
        { name: 'logo', src: require('@/assets/imgs/logo.png') },
        {
            name: 'dialog_close_btn',
            src: require('@/assets/imgs/dialog_close_btn.png')
        },
        { name: 'check', src: require('@/assets/imgs/check.png') },
        { name: 'chips', src: require('@/assets/imgs/chips.png') },
        { name: 'loading', src: require('@/assets/imgs/loading.png') },
        { name: 'chip-border', src: require('@/assets/imgs/chip-border.png') },
        { name: 'flags', src: require('@/assets/imgs/flags.png') },
        {
            name: 'but_table_cancelbet',
            src: require('@/assets/imgs/but_table_cancelbet.png')
        },
        {
            name: 'but_table_confirmbet',
            src: require('@/assets/imgs/but_table_confirmbet.png')
        },
        {
            name: 'icon_multiple_confirm',
            src: require('@/assets/imgs/icon_multiple_confirm.png')
        },
        {
            name: 'but_multiple_cancelbet',
            src: require('@/assets/imgs/but_multiple_cancelbet.png')
        },
        {
            name: 'but_multiple_confirmbet',
            src: require('@/assets/imgs/but_multiple_confirmbet.png')
        },
        { name: 'reserved', src: require('@/assets/imgs/reserved.png') },
        { name: 'bg_bet2', src: require('@/assets/imgs/bg_bet2.png') },
        {
            name: 'but_login_test',
            src: require('@/assets/imgs/but_login_test.png')
        },
        {
            name: 'but_login_confirm',
            src: require('@/assets/imgs/but_login_confirm.png')
        },
        {
            name: 'bg_pop_top_small',
            src: require('@/assets/imgs/bg_pop_top_small.png')
        },
        {
            name: 'bg_lobby_top',
            src: require('@/assets/imgs/bg_lobby_top.png')
        },
        {
            name: 'but_multiple_on',
            src: require('@/assets/imgs/but_multiple_on.png')
        },
        {
            name: 'but_bac_on',
            src: require('@/assets/imgs/but_bac_on.png')
        },
        {
            name: 'bg_multiple_chips',
            src: require('@/assets/imgs/bg_multiple_chips.png')
        },
        {
            name: 'bg_multiple_table',
            src: require('@/assets/imgs/bg_multiple_table.png')
        },
        {
            name: 'bg_pop_top',
            src: require('@/assets/imgs/bg_pop_top.png')
        },
        {
            name: 'switch_thumb',
            src: require('@/assets/imgs/switch_thumb.png')
        },
        {
            name: 'but_lobby_gift',
            src: require('@/assets/imgs/but_lobby_gift.png')
        },
        {
            name: 'bg_usdt',
            src: require('@/assets/imgs/bg_usdt.jpg')
        },
        {
            name: 'bg_pop_signin',
            src: require('@/assets/imgs/bg_pop_signin.jpg')
        },
        {
            name: 'arrow_right',
            src: require('@/assets/imgs/arrow_right.png')
        },
        {
            name: 'arrow_left',
            src: require('@/assets/imgs/arrow_left.png')
        },
        {
            name: 'but_table_confirm_bet',
            src: require('@/assets/imgs/pc/but_table_confirm_bet.png')
        },
        {
            name: 'but_table_cancel_bet',
            src: require('@/assets/imgs/pc/but_table_cancel_bet.png')
        },
        {
            name: 'but_table_repeat',
            src: require('@/assets/imgs/pc/but_table_repeat.png')
        }
    ]
    const mobileAssets: Asset[] = [
        {
            name: 'bg_login',
            src: require('@/assets/imgs/m/bg_login.png')
        },
        {
            name: 'but_login_test',
            src: require('@/assets/imgs/m/but_login_test.png')
        },
        {
            name: 'but_login_test_c',
            src: require('@/assets/imgs/m/but_login_test_c.png')
        },
        {
            name: 'bg_pop_top',
            src: require('@/assets/imgs/m/bg_pop_top.png')
        },
        {
            name: 'bg_lobby_top',
            src: require('@/assets/imgs/m/bg_lobby_top.png')
        },
        {
            name: 'm_logo',
            src: require('@/assets/imgs/m/m_logo.png')
        },
        {
            name: 'but_lobby_gift',
            src: require('@/assets/imgs/m/but_lobby_gift.png')
        },

        {
            name: 'but_changetable',
            src: require('@/assets/imgs/m/but_changetable.png')
        },
        {
            name: 'media_ctrl_bg',
            src: require('@/assets/imgs/m/media_ctrl_bg.png')
        },
        {
            name: 'bg_pop_signin',
            src: require('@/assets/imgs/m/bg_pop_signin.jpg')
        }
    ]

    const assets: Asset[] = [
        ...pcAssets,
        ...mobileAssets,
        {
            name: 'bear_8',
            src: require('@/assets/imgs/r-map/bear_8.png')
        },
        {
            name: 'small_tiger',
            src: require('@/assets/imgs/r-map/small_tiger.png')
        },
        {
            name: 'big_tiger',
            src: require('@/assets/imgs/r-map/big_tiger.png')
        },
        {
            name: 'dragon_7',
            src: require('@/assets/imgs/r-map/dragon_7.png')
        }
    ]
    const loadImageAsset = (res: Asset) => {
        return new Promise((resolve, reject) => {
            const img = new Image()

            img.src = res.src

            img.onload = () => {
                loadedCount++
                if (loadedCount === assets.length) isLoaded.value = true
                resolve(img)
            }

            img.onerror = img.onabort = () => {
                loadedCount++
                reject(res)
            }
        })
    }

    const loadImages = () => {
        assets.map((img) => loadImageAsset(img).catch((err) => err))
    }

    return {
        isLoaded,
        loadImages
    }
}
